export default "__VITE_ASSET__DHISH$ab__"